import React from 'react';
import Markdown from 'react-markdown';

const ThemeMarkdown = ({ children, components, ...props }) => {
  return (
    <Markdown
      {...props}
      components={{
        a: ({ node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">
            {props.children}
          </a>
        ),
        ...components,
      }}
    >
      {children}
    </Markdown>
  );
};
export default ThemeMarkdown;
